import { render } from "./fondocambiante_ingles.vue?vue&type=template&id=dff122f2&scoped=true"
import script from "./fondocambiante_ingles.vue?vue&type=script&lang=js"
export * from "./fondocambiante_ingles.vue?vue&type=script&lang=js"

import "./fondocambiante_ingles.vue?vue&type=style&index=0&id=dff122f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff122f2"]])

export default __exports__